module.exports = __webpack_public_path__ + "static/img/14001021.f5fe5ddf.png";